"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _rmcFeedback = _interopRequireDefault(require("rmc-feedback"));
var _excluded = ["prefixCls", "disabled", "onTouchStart", "onTouchEnd", "onMouseDown", "onMouseUp", "onMouseLeave"];
var InputHandler = function InputHandler(props) {
  var prefixCls = props.prefixCls,
    disabled = props.disabled,
    onTouchStart = props.onTouchStart,
    onTouchEnd = props.onTouchEnd,
    onMouseDown = props.onMouseDown,
    onMouseUp = props.onMouseUp,
    onMouseLeave = props.onMouseLeave,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_rmcFeedback["default"], {
    disabled: disabled,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onMouseLeave: onMouseLeave,
    activeClassName: "".concat(prefixCls, "-handler-active")
  }, /*#__PURE__*/_react["default"].createElement("span", otherProps));
};
InputHandler.displayName = 'RcInputHandler';
var _default = InputHandler;
exports["default"] = _default;